import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from './api.service';
import { ReturnObject } from '../model/returnobject';
import { User } from '../model/user';
import { AccessRoleItem } from '../model/accessroleitem';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

  constructor(private api: APIService) { }

  getUserInfo(userId: string): Observable<ReturnObject<User>> {
    return this.api.getAPINoUser(`userinfo`);
  }
}
